module.exports = __webpack_public_path__ + "img/card_01@2x.bfb1b179.png";